
const YTD2022 = {
  "columns": 12,
  "rows": 3,
  "visual": {
    "id": 1,
    "type": "historicalTableV2",
    "colorTheme": 'colorTheme1',
    "title": "YTD 2022",
    "binding": {
      "data": {
        "columns": [
          {
            "name": 'Product Name',
            "columnName": 'ItemName',
            "width": '200px',
            "align": "left",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Jan|Unit',
            "columnName": 'JanUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Jan|Peso',
            "columnName": 'JanPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },

          {
            "name": 'Feb|Unit',
            "columnName": 'FebUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Feb|Peso',
            "columnName": 'FebPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Mar|Unit',
            "columnName": 'MarUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
           {
            "name": 'Mar|Peso',
            "columnName": 'MarPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Apr|Unit',
            "columnName": 'AprUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Apr|Peso',
            "columnName": 'AprPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },

          {
            "name": 'May|Unit',
            "columnName": 'MayUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'May|Peso',
            "columnName": 'MayPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Jun|Unit',
            "columnName": 'JunUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
                 {
            "name": 'Jun|Peso',
            "columnName": 'JunPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Jul|Unit',
            "columnName": 'JulUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Jul|Peso',
            "columnName": 'JulPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Aug|Unit',
            "columnName": 'AugUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Aug|Peso',
            "columnName": 'AugPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Sep|Unit',
            "columnName": 'SepUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Sep|Peso',
            "columnName": 'SepPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Oct|Unit',
            "columnName": 'OctUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Oct|Peso',
            "columnName": 'OctPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Nov|Unit',
            "columnName": 'NovUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Nov|Peso',
            "columnName": 'NovPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Dec|Unit',
            "columnName": 'DecUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Dec|Peso',
            "columnName": 'DecPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Total|Unit',
            "columnName": 'TotalUnit',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
           {
            "name": 'Total|Peso',
            "columnName": 'TotalPeso',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          }
        ],
        "title": "YTD2022",
        "endpoint": "N76",
        "parameters": [
          { "key": "Year", "value": "2022" },
          { "key": "ConfigTypeCode", "value": "Y2025" }
        ]
      },
      "context": {
        "point": {
          "onClick": {
          }
        }
      }
    }
  }
}  
const YTD2023 = {
  "columns": 12,
  "rows": 2,
  "visual": {
    "id": 1,
    "type": "historicalTableV2",
    "colorTheme": 'colorTheme1',
    "title": "YTD 2023",
    "binding": {
      "data": {
        "columns": [
          {
            "name": 'Product Name',
            "columnName": 'ItemName',
            "width": '200px',
            "align": "left",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Jan|Unit',
            "columnName": 'JanUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Jan|Peso',
            "columnName": 'JanPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },

          {
            "name": 'Feb|Unit',
            "columnName": 'FebUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Feb|Peso',
            "columnName": 'FebPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Mar|Unit',
            "columnName": 'MarUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
           {
            "name": 'Mar|Peso',
            "columnName": 'MarPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Apr|Unit',
            "columnName": 'AprUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Apr|Peso',
            "columnName": 'AprPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },

          {
            "name": 'May|Unit',
            "columnName": 'MayUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'May|Peso',
            "columnName": 'MayPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Jun|Unit',
            "columnName": 'JunUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
                 {
            "name": 'Jun|Peso',
            "columnName": 'JunPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Jul|Unit',
            "columnName": 'JulUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Jul|Peso',
            "columnName": 'JulPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Aug|Unit',
            "columnName": 'AugUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Aug|Peso',
            "columnName": 'AugPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Sep|Unit',
            "columnName": 'SepUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Sep|Peso',
            "columnName": 'SepPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Oct|Unit',
            "columnName": 'OctUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Oct|Peso',
            "columnName": 'OctPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Nov|Unit',
            "columnName": 'NovUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Nov|Peso',
            "columnName": 'NovPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Dec|Unit',
            "columnName": 'DecUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Dec|Peso',
            "columnName": 'DecPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Total|Unit',
            "columnName": 'TotalUnit',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
           {
            "name": 'Total|Peso',
            "columnName": 'TotalPeso',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          }
        ],
        "title": "YTD2022",
        "endpoint": "N76",
        "parameters": [
          { "key": "Year", "value": "2023" },
          { "key": "ConfigTypeCode", "value": "Y2025" }
        ]
      },
      "context": {
        "point": {
          "onClick": {
          }
        }
      }
    }
  }
}  
const YTD2024 = {
  "columns": 12,
  "rows": 2,
  "visual": {
    "id": 1,
    "type": "historicalTableV2",
    "colorTheme": 'colorTheme1',
    "title": "YTD 2024",
    "binding": {
      "data": {
        "columns": [
          {
            "name": 'Product Name',
            "columnName": 'ItemName',
            "width": '200px',
            "align": "left",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Jan|Unit',
            "columnName": 'JanUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Jan|Peso',
            "columnName": 'JanPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },

          {
            "name": 'Feb|Unit',
            "columnName": 'FebUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Feb|Peso',
            "columnName": 'FebPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Mar|Unit',
            "columnName": 'MarUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
           {
            "name": 'Mar|Peso',
            "columnName": 'MarPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Apr|Unit',
            "columnName": 'AprUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Apr|Peso',
            "columnName": 'AprPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },

          {
            "name": 'May|Unit',
            "columnName": 'MayUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'May|Peso',
            "columnName": 'MayPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Jun|Unit',
            "columnName": 'JunUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
                 {
            "name": 'Jun|Peso',
            "columnName": 'JunPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Jul|Unit',
            "columnName": 'JulUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Jul|Peso',
            "columnName": 'JulPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Aug|Unit',
            "columnName": 'AugUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Aug|Peso',
            "columnName": 'AugPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Sep|Unit',
            "columnName": 'SepUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Sep|Peso',
            "columnName": 'SepPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Oct|Unit',
            "columnName": 'OctUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Oct|Peso',
            "columnName": 'OctPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Nov|Unit',
            "columnName": 'NovUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Nov|Peso',
            "columnName": 'NovPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Dec|Unit',
            "columnName": 'DecUNIT',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Dec|Peso',
            "columnName": 'DecPESO',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Total|Unit',
            "columnName": 'TotalUnit',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          },
           {
            "name": 'Total|Peso',
            "columnName": 'TotalPeso',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": false
          }
        ],
        "title": "YTD2022",
        "endpoint": "N76",
        "parameters": [
          { "key": "Year", "value": "2024" },
          { "key": "ConfigTypeCode", "value": "Y2025" }
        ]
      },
      "context": {
        "point": {
          "onClick": {
          }
        }
      }
    }
  }
}  

export const ProductComparativeYOY = {
  "sections": [
    YTD2022,
    YTD2023,
    YTD2024
  ]
}